import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { IdProductsState } from 'model/dashboardProducts/dProductsReducer';
import { Alert } from 'components/UI/Alert/Alert';
import { IMPORT_VARIANT } from 'components/containers/dashboard/dataProducts/popupContents/popupImport';
import { InputFile } from 'components/UI/InputFile/InputFile';
import { ArrowLeftIcon, CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/outline';
import {dProductsImportDataSagaAC} from "../../../../../../../model/dashboardProducts/dProductsActionCreators";


// Type
export type typeImportFileBlock = {
    variant?: string
    setOpenBlock: React.Dispatch<React.SetStateAction<boolean>>
    setOpenSelectStoresBlock: React.Dispatch<React.SetStateAction<boolean>>
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
    importVariant: IMPORT_VARIANT
    selectedStoresIds: string[]
}


// Component
export const ImportFileBlock: React.FC<typeImportFileBlock> = ({
                                                                   variant,
                                                                   setOpenPopup,
                                                                   setOpenBlock,
                                                                   setOpenSelectStoresBlock,
                                                                   selectedStoresIds,
                                                                   importVariant
                                                               }) => {

    const dispatch = useDispatch()

    const filters = useSelector((state: { dProducts: IdProductsState }) => state.dProducts.filters)
    const pagination = useSelector((state: { dProducts: IdProductsState }) => state.dProducts.pagination)


    // select title for Alert  depends on  selected variant of import
    const title = () => {
        switch (importVariant) {
            case IMPORT_VARIANT.CATALOG:
                return <Trans>Selected import option: <b>to a catalog</b>, without any stores and price from the file</Trans>
            case IMPORT_VARIANT.COMMON:
                return <Trans>Selected import option:<b> all data from the file</b> (as usual)</Trans>
            case IMPORT_VARIANT.STORES:
                return <Trans>Selected import option:  <b>to selected stores</b>. Number of selected stores: <b>{ selectedStoresIds.length }</b></Trans>
            default:
                return <Trans></Trans>
        }
    }


    // file import

    const [ file, setFile ] = useState<File | null>(null)

    const onChangeHandler = (files: FileList | null) => {

        if (files && files?.length) {
            setFile(files[0])
        }

    }

    const onBackHandler = () => {
        if (importVariant === IMPORT_VARIANT.STORES) {
            setOpenBlock(false)
            setOpenSelectStoresBlock(true)
        } else {
            setOpenBlock(false)
        }
    }

    const onImportHandler = (e: React.FormEvent) => {
        e.preventDefault()
        if (!file) {return}

        const formData = new FormData()

        const filterObject = {
            importType: importVariant,
            storeIds: selectedStoresIds
        }

        if (file) {
            formData.append(
                'file',
                file,
                file.name
            )
            console.log('filterObject', filterObject)
            formData.append(
                'filter',
                new Blob([ JSON.stringify(filterObject) ], {
                    type: 'application/json',
                }),
            )

            dispatch(dProductsImportDataSagaAC(formData, filters, {
                page: pagination.pageNumber,
                size: pagination.itemsPerPage!
            }))

        }

        setOpenPopup(false)
    }

    const MAX_FILE_SIZE = 10485760


    return (
        <>
            <form onSubmit={ (e) => onImportHandler(e) }
                  className={ 'flex flex-col gap-2 w-50vw' }
            >
                <div className={ 'flex flex-col gap-6' }>
                    <Alert type={ 'info' }
                           title={ title() }
                           textColor={'text-gray-600'}
                    />
                    <div className="flex justify-center mt-2">
                        <InputFile id="file" accept=".xlsx" onChange={ onChangeHandler }
                                   comment={ <Trans>XLSX up to 10MB</Trans> }/>
                    </div>

                    { file && file.size > MAX_FILE_SIZE
                        ? <div className=" text-sm text-red-500 flex gap-x-1">
                            <ExclamationCircleIcon className="h-5 w-5 "/><Trans>The size of the selected file is more
                            than 10MB.</Trans>
                        </div>
                        : null
                    }

                    { file
                        ? <div className="text-sm text-gray-500 flex gap-x-1 justify-center">
                            <CheckCircleIcon className="h-5 w-5 text-primary-500"/><Trans>Selected file:</Trans><span
                            className="text-gray-900 text-md">{ file.name }</span>
                        </div>
                        : null
                    }
                    <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                        <Button type="submit" disabled={ file && file.size <= MAX_FILE_SIZE ? false : true }
                                variant={ variant }
                                label={ <Trans>Import</Trans> }/>
                        <Button type="button" secondary={ true } label={ <Trans>Back to previous step</Trans> }
                                onClick={ onBackHandler }
                                icon={ <ArrowLeftIcon className={ 'w-4 h-4 text-gray-400 mr-3' }/> }
                        />
                    </div>

                </div>


            </form>
        </>
    )
}
